/** Extracts the active projectId from a URL pathname (/sacrifice/:id/...). Returns null if none. */
export const getProjectIdFromPath = (pathname: string): string | null => {
  const segments = pathname.split('/')
  if (segments[1] === 'sacrifice' && segments[2]) {
    return segments[2]
  }
  return null
}
